import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Helmet from 'react-helmet';
import 'office-ui-fabric-core/dist/css/fabric.css';
import '@formatjs/intl-getcanonicallocales/polyfill';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en'; // locale-data for en
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/en'; // locale-data for en
import '@formatjs/intl-datetimeformat/polyfill';
import '@formatjs/intl-datetimeformat/locale-data/en'; // locale-data for en
import '@formatjs/intl-datetimeformat/add-all-tz'; // Add ALL tz data
import Header from '@widgets/header/Header';
import Footer from '@widgets/footer/Footer';
import HomeHero from '@components/homeHero/HomeHero';
import Breadcrumbs from '@widgets/breadcrumbs/Breadcrumbs';
import InsightDetails from '@components/insights/InsightDetails';
import FilterSelector from '@components/filterSelector/FilterSelector';
import PeopleBioPage from '@components/people/PeopleBioPage';
import PeopleItem from '@components/people/PersonCard';
import PeopleCardsGrid from '@components/people/PeopleCardsGrid';
import ApiExample from '@widgets/apiExample/ApiExample';
import InsightCarouselWidget from '@widgets/insightCarouselWidget/insightCarouselWidget';
import HeroWidgetHeader from '@widgets/hero/HeroWidgetHeader';
import TiledLinkSectionWidget from '@widgets/tiledLinkSectionWidget/TiledLinkSectionWidget';
import FlexibleBannerWidget from '@widgets/flexibleBanner/FlexibleBannerWidget';
import KeyContactsWidget from '@widgets/keyContactsWidget/KeyContactsWidget';
import CardsGrid from '@components/insightLanding/cardsGrid';
import TrendingTopics from '@components/trendingTopics/TrendingTopics';
import IndustrySecondary from '@components/industries/IndustrySecondary';
import IndustryPrimary from '@components/industries/IndustryPrimary';
import ServiceContent from '@components/services/ServiceContent';
import SideBoxNavigation from '@components/services/SideBoxNavigation';
import LocalNavigationWidget from '@widgets/localNavigation/LocalNavigationWidget';
import GlobalLocationsList from '@components/locations/GlobalLocationsList';
import LocalLocationsList from '@components/locations/LocalLocationsList';
import LocationsCity from '@components/locations/LocationsCity';
import TrendingTopicsCarouselWidget from '@widgets/trendingTopicsCarouselWidget/TrendingTopicsCarouselWidget';
import AccordionWidget from '@widgets/accordionWidget/AccordionWidget';
import MultiLinksCardsGrid from '@components/cards/MultiLinksCardsGrid';
import CareersCardsGrid from '@components/careers/CareersCardsGrid';
import QuoteCardWidget from '@widgets/quoteCardWidget/QuoteCardWidget';
import ContentTabAccordion from '@widgets/contentTabAccordionWidget/ContentTabAccordionWidget';
import ButtonWidget from '@widgets/buttonWidget/ButtonWidget';
import ImageWithTextWidget from '@widgets/imageWithTextWidget/ImageWithTextWidget';
import EventsAndWebinarsCarouselWidget from '@widgets/eventsWebinars/EventsAndWebinarsCarouselWidget';
import LegalBodyContent from '@components/legal/LegalBodyContent';
import LegalSideBoxNavigation from '@components/legal/LegalSideBoxNavigaton';
import ErrorPageContent from '@components/error/ErrorPageContent';
import ContactPageDescriptionText from '@components/contacts/ContactPageDescriptionText';
import LocalNavigationItem from '@widgets/localNavigation/LocalNavigationItem';
import LocalNavigationJS from '@widgets/localNavigation/LocalNavigationJS';
import EventsCardsGrid from '@components/events/EventsCardsGrid';
import EventsWebinarsDetails from '@components/events/EventsWebinarDetails';
import RssFeeds from '@components/rss/RssFeeds';
import FormStylingJS from '@widgets/form/FormStylingJS';
import SearchResults from '@components/searchResults/SearchResults';
import Sitemap from '@components/sitemap/Sitemap';
import CookieBanner from '@widgets/cookie/CookieBanner';
import SubscribePageHeader from '@components/subscribe/SubscribePageHeader';
import SubscribePageFooter from '@components/subscribe/SubscribePageFooter';
import SubscribeForm from '@components/subscribe/SubscribeForm';
import SeeAllLocationsWidget from '@widgets/seeAllLocationsWidget/SeeAllLocationsWidget';
import DealDetails from '@components/deals/DealDetails';
import CareerDetails from '@components/careers/CareerDetails';
import CareerSidebar from '@components/careers/CareerSidebar';
import DealsCardsGrid from '@components/deals/DealsCardsGrid';
import BusinessStrategiesGrid from '@components/businessStrategies/BusinessStrategiesGrid';
import OrderedPageSelectorObserver from '@utils/orderedPageSelector';
import NewsCarouselWidget from '@widgets/newsCarouselWidget/NewsCarouselWidget';
import SocialMediaWidget from '@widgets/socialMediaWidget/SocialMediaWidget';
import '@utils/formHelper';
global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.Helmet = Helmet;
global.Header = Header;
global.Footer = Footer;
global.HomeHero = HomeHero;
global.Breadcrumbs = Breadcrumbs;
global.FilterSelector = FilterSelector;
global.PeopleBio = PeopleBioPage;
global.PeopleItem = PeopleItem;
global.PeopleCardsGrid = PeopleCardsGrid;
global.ApiExample = ApiExample;
global.InsightCarousel = InsightCarouselWidget;
global.HeroWidget = HeroWidgetHeader;
global.AccordionWidget = AccordionWidget;
global.TiledLinkSection = TiledLinkSectionWidget;
global.InsightDetails = InsightDetails;
global.FlexibleBanner = FlexibleBannerWidget;
global.KeyContactsWidget = KeyContactsWidget;
global.CardsGrid = CardsGrid;
global.TrendingTopics = TrendingTopics;
global.IndustrySecondary = IndustrySecondary;
global.IndustryPrimary = IndustryPrimary;
global.ServiceContent = ServiceContent;
global.SideBoxNavigation = SideBoxNavigation;
global.LocalNavigationWidget = LocalNavigationWidget;
global.LocalNavigationItem = LocalNavigationItem;
global.LocalNavigationJS = LocalNavigationJS;
global.GlobalLocationsList = GlobalLocationsList;
global.LocalLocationsList = LocalLocationsList;
global.LocationsCity = LocationsCity;
global.TrendingTopicsCarouselWidget = TrendingTopicsCarouselWidget;
global.MultiLinksCardsGrid = MultiLinksCardsGrid;
global.QuoteCardWidget = QuoteCardWidget;
global.ContentTabAccordion = ContentTabAccordion;
global.ButtonWidget = ButtonWidget;
global.ImageWithTextWidget = ImageWithTextWidget;
global.EventsAndWebinarsCarousel = EventsAndWebinarsCarouselWidget;
global.LegalBodyContent = LegalBodyContent;
global.LegalSideBoxNavigation = LegalSideBoxNavigation;
global.ErrorPageContent = ErrorPageContent;
global.ContactPageDescriptionText = ContactPageDescriptionText;
global.EventsCardsGrid = EventsCardsGrid;
global.RssFeeds = RssFeeds;
global.FormStylingJS = FormStylingJS;
global.SearchResults = SearchResults;
global.Sitemap = Sitemap;
global.CookieBanner = CookieBanner;
global.SubscribePageHeader = SubscribePageHeader;
global.SubscribePageFooter = SubscribePageFooter;
global.SubscribeForm = SubscribeForm;
global.SeeAllLocationsWidget = SeeAllLocationsWidget;
global.EventsWebinarsDetails = EventsWebinarsDetails;
global.DealDetails = DealDetails;
global.CareersCardsGrid = CareersCardsGrid;
global.CareerDetails = CareerDetails;
global.CareerSidebar = CareerSidebar;
global.DealsCardsGrid = DealsCardsGrid;
global.BusinessStrategiesGrid = BusinessStrategiesGrid;
global.OrderedPageSelectorObserver = new OrderedPageSelectorObserver();
global.NewsCarousel = NewsCarouselWidget;
global.SocialMedia = SocialMediaWidget;
